/**
 * whatsapp-signup.js — Little Giants / Fabric theme
 * Powers the `blocks/whatsapp-signup.liquid` footer block.
 * Re-scoped per block.id so multiple instances (e.g. footer + elsewhere)
 * never collide on element IDs or selected-country state.
 */
(function () {
  'use strict';

  var _C = [
    {code:'+92',  flag:'🇵🇰', name:'Pakistan'},
    {code:'+93',  flag:'🇦🇫', name:'Afghanistan'},
    {code:'+355', flag:'🇦🇱', name:'Albania'},
    {code:'+213', flag:'🇩🇿', name:'Algeria'},
    {code:'+376', flag:'🇦🇩', name:'Andorra'},
    {code:'+244', flag:'🇦🇴', name:'Angola'},
    {code:'+1',   flag:'🇦🇮', name:'Anguilla'},
    {code:'+1',   flag:'🇦🇬', name:'Antigua and Barbuda'},
    {code:'+54',  flag:'🇦🇷', name:'Argentina'},
    {code:'+374', flag:'🇦🇲', name:'Armenia'},
    {code:'+297', flag:'🇦🇼', name:'Aruba'},
    {code:'+61',  flag:'🇦🇺', name:'Australia'},
    {code:'+43',  flag:'🇦🇹', name:'Austria'},
    {code:'+994', flag:'🇦🇿', name:'Azerbaijan'},
    {code:'+1',   flag:'🇧🇸', name:'Bahamas'},
    {code:'+973', flag:'🇧🇭', name:'Bahrain'},
    {code:'+880', flag:'🇧🇩', name:'Bangladesh'},
    {code:'+1',   flag:'🇧🇧', name:'Barbados'},
    {code:'+375', flag:'🇧🇾', name:'Belarus'},
    {code:'+32',  flag:'🇧🇪', name:'Belgium'},
    {code:'+501', flag:'🇧🇿', name:'Belize'},
    {code:'+229', flag:'🇧🇯', name:'Benin'},
    {code:'+1',   flag:'🇧🇲', name:'Bermuda'},
    {code:'+975', flag:'🇧🇹', name:'Bhutan'},
    {code:'+591', flag:'🇧🇴', name:'Bolivia'},
    {code:'+387', flag:'🇧🇦', name:'Bosnia and Herzegovina'},
    {code:'+267', flag:'🇧🇼', name:'Botswana'},
    {code:'+55',  flag:'🇧🇷', name:'Brazil'},
    {code:'+673', flag:'🇧🇳', name:'Brunei'},
    {code:'+359', flag:'🇧🇬', name:'Bulgaria'},
    {code:'+226', flag:'🇧🇫', name:'Burkina Faso'},
    {code:'+257', flag:'🇧🇮', name:'Burundi'},
    {code:'+855', flag:'🇰🇭', name:'Cambodia'},
    {code:'+237', flag:'🇨🇲', name:'Cameroon'},
    {code:'+1',   flag:'🇨🇦', name:'Canada'},
    {code:'+238', flag:'🇨🇻', name:'Cape Verde'},
    {code:'+1',   flag:'🇰🇾', name:'Cayman Islands'},
    {code:'+236', flag:'🇨🇫', name:'Central African Republic'},
    {code:'+235', flag:'🇹🇩', name:'Chad'},
    {code:'+56',  flag:'🇨🇱', name:'Chile'},
    {code:'+86',  flag:'🇨🇳', name:'China'},
    {code:'+57',  flag:'🇨🇴', name:'Colombia'},
    {code:'+269', flag:'🇰🇲', name:'Comoros'},
    {code:'+242', flag:'🇨🇬', name:'Congo'},
    {code:'+243', flag:'🇨🇩', name:'Congo (DRC)'},
    {code:'+682', flag:'🇨🇰', name:'Cook Islands'},
    {code:'+506', flag:'🇨🇷', name:'Costa Rica'},
    {code:'+385', flag:'🇭🇷', name:'Croatia'},
    {code:'+53',  flag:'🇨🇺', name:'Cuba'},
    {code:'+357', flag:'🇨🇾', name:'Cyprus'},
    {code:'+420', flag:'🇨🇿', name:'Czech Republic'},
    {code:'+45',  flag:'🇩🇰', name:'Denmark'},
    {code:'+253', flag:'🇩🇯', name:'Djibouti'},
    {code:'+1',   flag:'🇩🇲', name:'Dominica'},
    {code:'+1',   flag:'🇩🇴', name:'Dominican Republic'},
    {code:'+593', flag:'🇪🇨', name:'Ecuador'},
    {code:'+20',  flag:'🇪🇬', name:'Egypt'},
    {code:'+503', flag:'🇸🇻', name:'El Salvador'},
    {code:'+240', flag:'🇬🇶', name:'Equatorial Guinea'},
    {code:'+291', flag:'🇪🇷', name:'Eritrea'},
    {code:'+372', flag:'🇪🇪', name:'Estonia'},
    {code:'+268', flag:'🇸🇿', name:'Eswatini'},
    {code:'+251', flag:'🇪🇹', name:'Ethiopia'},
    {code:'+679', flag:'🇫🇯', name:'Fiji'},
    {code:'+358', flag:'🇫🇮', name:'Finland'},
    {code:'+33',  flag:'🇫🇷', name:'France'},
    {code:'+689', flag:'🇵🇫', name:'French Polynesia'},
    {code:'+241', flag:'🇬🇦', name:'Gabon'},
    {code:'+220', flag:'🇬🇲', name:'Gambia'},
    {code:'+995', flag:'🇬🇪', name:'Georgia'},
    {code:'+49',  flag:'🇩🇪', name:'Germany'},
    {code:'+233', flag:'🇬🇭', name:'Ghana'},
    {code:'+350', flag:'🇬🇮', name:'Gibraltar'},
    {code:'+30',  flag:'🇬🇷', name:'Greece'},
    {code:'+299', flag:'🇬🇱', name:'Greenland'},
    {code:'+1',   flag:'🇬🇩', name:'Grenada'},
    {code:'+1',   flag:'🇬🇺', name:'Guam'},
    {code:'+502', flag:'🇬🇹', name:'Guatemala'},
    {code:'+224', flag:'🇬🇳', name:'Guinea'},
    {code:'+245', flag:'🇬🇼', name:'Guinea-Bissau'},
    {code:'+592', flag:'🇬🇾', name:'Guyana'},
    {code:'+509', flag:'🇭🇹', name:'Haiti'},
    {code:'+504', flag:'🇭🇳', name:'Honduras'},
    {code:'+852', flag:'🇭🇰', name:'Hong Kong'},
    {code:'+36',  flag:'🇭🇺', name:'Hungary'},
    {code:'+354', flag:'🇮🇸', name:'Iceland'},
    {code:'+91',  flag:'🇮🇳', name:'India'},
    {code:'+62',  flag:'🇮🇩', name:'Indonesia'},
    {code:'+98',  flag:'🇮🇷', name:'Iran'},
    {code:'+964', flag:'🇮🇶', name:'Iraq'},
    {code:'+353', flag:'🇮🇪', name:'Ireland'},
    {code:'+972', flag:'🇮🇱', name:'Israel'},
    {code:'+39',  flag:'🇮🇹', name:'Italy'},
    {code:'+1',   flag:'🇯🇲', name:'Jamaica'},
    {code:'+81',  flag:'🇯🇵', name:'Japan'},
    {code:'+962', flag:'🇯🇴', name:'Jordan'},
    {code:'+7',   flag:'🇰🇿', name:'Kazakhstan'},
    {code:'+254', flag:'🇰🇪', name:'Kenya'},
    {code:'+686', flag:'🇰🇮', name:'Kiribati'},
    {code:'+383', flag:'🇽🇰', name:'Kosovo'},
    {code:'+965', flag:'🇰🇼', name:'Kuwait'},
    {code:'+996', flag:'🇰🇬', name:'Kyrgyzstan'},
    {code:'+856', flag:'🇱🇦', name:'Laos'},
    {code:'+371', flag:'🇱🇻', name:'Latvia'},
    {code:'+961', flag:'🇱🇧', name:'Lebanon'},
    {code:'+266', flag:'🇱🇸', name:'Lesotho'},
    {code:'+231', flag:'🇱🇷', name:'Liberia'},
    {code:'+218', flag:'🇱🇾', name:'Libya'},
    {code:'+423', flag:'🇱🇮', name:'Liechtenstein'},
    {code:'+370', flag:'🇱🇹', name:'Lithuania'},
    {code:'+352', flag:'🇱🇺', name:'Luxembourg'},
    {code:'+853', flag:'🇲🇴', name:'Macau'},
    {code:'+261', flag:'🇲🇬', name:'Madagascar'},
    {code:'+265', flag:'🇲🇼', name:'Malawi'},
    {code:'+60',  flag:'🇲🇾', name:'Malaysia'},
    {code:'+960', flag:'🇲🇻', name:'Maldives'},
    {code:'+223', flag:'🇲🇱', name:'Mali'},
    {code:'+356', flag:'🇲🇹', name:'Malta'},
    {code:'+692', flag:'🇲🇭', name:'Marshall Islands'},
    {code:'+222', flag:'🇲🇷', name:'Mauritania'},
    {code:'+230', flag:'🇲🇺', name:'Mauritius'},
    {code:'+52',  flag:'🇲🇽', name:'Mexico'},
    {code:'+691', flag:'🇫🇲', name:'Micronesia'},
    {code:'+373', flag:'🇲🇩', name:'Moldova'},
    {code:'+377', flag:'🇲🇨', name:'Monaco'},
    {code:'+976', flag:'🇲🇳', name:'Mongolia'},
    {code:'+382', flag:'🇲🇪', name:'Montenegro'},
    {code:'+212', flag:'🇲🇦', name:'Morocco'},
    {code:'+258', flag:'🇲🇿', name:'Mozambique'},
    {code:'+95',  flag:'🇲🇲', name:'Myanmar'},
    {code:'+264', flag:'🇳🇦', name:'Namibia'},
    {code:'+674', flag:'🇳🇷', name:'Nauru'},
    {code:'+977', flag:'🇳🇵', name:'Nepal'},
    {code:'+31',  flag:'🇳🇱', name:'Netherlands'},
    {code:'+687', flag:'🇳🇨', name:'New Caledonia'},
    {code:'+64',  flag:'🇳🇿', name:'New Zealand'},
    {code:'+505', flag:'🇳🇮', name:'Nicaragua'},
    {code:'+227', flag:'🇳🇪', name:'Niger'},
    {code:'+234', flag:'🇳🇬', name:'Nigeria'},
    {code:'+850', flag:'🇰🇵', name:'North Korea'},
    {code:'+389', flag:'🇲🇰', name:'North Macedonia'},
    {code:'+47',  flag:'🇳🇴', name:'Norway'},
    {code:'+968', flag:'🇴🇲', name:'Oman'},
    {code:'+680', flag:'🇵🇼', name:'Palau'},
    {code:'+970', flag:'🇵🇸', name:'Palestine'},
    {code:'+507', flag:'🇵🇦', name:'Panama'},
    {code:'+675', flag:'🇵🇬', name:'Papua New Guinea'},
    {code:'+595', flag:'🇵🇾', name:'Paraguay'},
    {code:'+51',  flag:'🇵🇪', name:'Peru'},
    {code:'+63',  flag:'🇵🇭', name:'Philippines'},
    {code:'+48',  flag:'🇵🇱', name:'Poland'},
    {code:'+351', flag:'🇵🇹', name:'Portugal'},
    {code:'+1',   flag:'🇵🇷', name:'Puerto Rico'},
    {code:'+974', flag:'🇶🇦', name:'Qatar'},
    {code:'+40',  flag:'🇷🇴', name:'Romania'},
    {code:'+7',   flag:'🇷🇺', name:'Russia'},
    {code:'+250', flag:'🇷🇼', name:'Rwanda'},
    {code:'+1',   flag:'🇰🇳', name:'Saint Kitts and Nevis'},
    {code:'+1',   flag:'🇱🇨', name:'Saint Lucia'},
    {code:'+1',   flag:'🇻🇨', name:'Saint Vincent and the Grenadines'},
    {code:'+685', flag:'🇼🇸', name:'Samoa'},
    {code:'+378', flag:'🇸🇲', name:'San Marino'},
    {code:'+239', flag:'🇸🇹', name:'Sao Tome and Principe'},
    {code:'+966', flag:'🇸🇦', name:'Saudi Arabia'},
    {code:'+221', flag:'🇸🇳', name:'Senegal'},
    {code:'+381', flag:'🇷🇸', name:'Serbia'},
    {code:'+248', flag:'🇸🇨', name:'Seychelles'},
    {code:'+232', flag:'🇸🇱', name:'Sierra Leone'},
    {code:'+65',  flag:'🇸🇬', name:'Singapore'},
    {code:'+421', flag:'🇸🇰', name:'Slovakia'},
    {code:'+386', flag:'🇸🇮', name:'Slovenia'},
    {code:'+677', flag:'🇸🇧', name:'Solomon Islands'},
    {code:'+252', flag:'🇸🇴', name:'Somalia'},
    {code:'+27',  flag:'🇿🇦', name:'South Africa'},
    {code:'+82',  flag:'🇰🇷', name:'South Korea'},
    {code:'+211', flag:'🇸🇸', name:'South Sudan'},
    {code:'+34',  flag:'🇪🇸', name:'Spain'},
    {code:'+94',  flag:'🇱🇰', name:'Sri Lanka'},
    {code:'+249', flag:'🇸🇩', name:'Sudan'},
    {code:'+597', flag:'🇸🇷', name:'Suriname'},
    {code:'+46',  flag:'🇸🇪', name:'Sweden'},
    {code:'+41',  flag:'🇨🇭', name:'Switzerland'},
    {code:'+963', flag:'🇸🇾', name:'Syria'},
    {code:'+886', flag:'🇹🇼', name:'Taiwan'},
    {code:'+992', flag:'🇹🇯', name:'Tajikistan'},
    {code:'+255', flag:'🇹🇿', name:'Tanzania'},
    {code:'+66',  flag:'🇹🇭', name:'Thailand'},
    {code:'+670', flag:'🇹🇱', name:'Timor-Leste'},
    {code:'+228', flag:'🇹🇬', name:'Togo'},
    {code:'+676', flag:'🇹🇴', name:'Tonga'},
    {code:'+1',   flag:'🇹🇹', name:'Trinidad and Tobago'},
    {code:'+216', flag:'🇹🇳', name:'Tunisia'},
    {code:'+90',  flag:'🇹🇷', name:'Turkey'},
    {code:'+993', flag:'🇹🇲', name:'Turkmenistan'},
    {code:'+1',   flag:'🇹🇨', name:'Turks and Caicos Islands'},
    {code:'+256', flag:'🇺🇬', name:'Uganda'},
    {code:'+380', flag:'🇺🇦', name:'Ukraine'},
    {code:'+971', flag:'🇦🇪', name:'UAE'},
    {code:'+44',  flag:'🇬🇧', name:'United Kingdom'},
    {code:'+1',   flag:'🇺🇸', name:'United States'},
    {code:'+598', flag:'🇺🇾', name:'Uruguay'},
    {code:'+998', flag:'🇺🇿', name:'Uzbekistan'},
    {code:'+678', flag:'🇻🇺', name:'Vanuatu'},
    {code:'+58',  flag:'🇻🇪', name:'Venezuela'},
    {code:'+84',  flag:'🇻🇳', name:'Vietnam'},
    {code:'+967', flag:'🇾🇪', name:'Yemen'},
    {code:'+260', flag:'🇿🇲', name:'Zambia'},
    {code:'+263', flag:'🇿🇼', name:'Zimbabwe'}
  ];

  // Per-block-instance selected country state
  var _sel = {};

  function _defaultSel() {
    return _C[0];
  }

  function _render(blockId, list) {
    var ul = document.getElementById('hub-wa-country-ul-' + blockId);
    if (!ul) return;
    var current = _sel[blockId] || _defaultSel();
    ul.innerHTML = '';
    list.forEach(function (c) {
      var isActive = c.code === current.code && c.name === current.name;
      var li = document.createElement('li');
      if (isActive) li.style.fontWeight = '600';
      li.onmouseover = function () { this.style.background = 'rgb(var(--color-foreground-rgb) / 0.08)'; };
      li.onmouseout  = function () { this.style.background = ''; };
      li.onclick = (function (country) {
        return function () { window.hubWaSelectCountry(country.code, country.flag, country.name, blockId); };
      })(c);

      var flagSpan = document.createElement('span');
      flagSpan.textContent = c.flag;
      var nameSpan = document.createElement('span');
      nameSpan.textContent = c.name;
      nameSpan.style.cssText = 'flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';
      var codeSpan = document.createElement('span');
      codeSpan.style.cssText = 'opacity:.5;font-size:12px;flex-shrink:0;';
      codeSpan.textContent = c.code;

      li.appendChild(flagSpan);
      li.appendChild(nameSpan);
      li.appendChild(codeSpan);
      ul.appendChild(li);
    });
  }

  window.hubWaToggleCountry = function (e, blockId) {
    e.stopPropagation();
    var drop = document.getElementById('hub-wa-country-drop-' + blockId);
    var srch = document.getElementById('hub-wa-country-search-' + blockId);
    if (!drop) return;
    var open = drop.style.display !== 'none' && drop.style.display !== '';
    drop.style.display = open ? 'none' : 'block';
    if (!open) {
      _render(blockId, _C);
      if (srch) { srch.value = ''; setTimeout(function () { srch.focus(); }, 30); }
    }
  };

  window.hubWaFilterCountry = function (q, blockId) {
    var lq = (q || '').toLowerCase().trim();
    _render(blockId, !lq ? _C : _C.filter(function (c) {
      return c.name.toLowerCase().indexOf(lq) >= 0 || c.code.indexOf(lq) >= 0;
    }));
  };

  window.hubWaSelectCountry = function (code, flag, name, blockId) {
    _sel[blockId] = { code: code, flag: flag, name: name };
    var flagEl = document.getElementById('hub-wa-code-flag-' + blockId);
    var codeEl = document.getElementById('hub-wa-code-val-' + blockId);
    var dropEl = document.getElementById('hub-wa-country-drop-' + blockId);
    if (flagEl) flagEl.textContent = flag;
    if (codeEl) codeEl.textContent = code;
    if (dropEl) dropEl.style.display = 'none';
  };

  document.addEventListener('click', function (e) {
    document.querySelectorAll('.whatsapp-signup__country-wrap').forEach(function (wrap) {
      if (wrap.contains(e.target)) return;
      var drop = wrap.querySelector('.whatsapp-signup__country-drop');
      if (drop) drop.style.display = 'none';
    });
  });

  window.hubWaSubscribe = function (blockId) {
    var nameEl  = document.getElementById('hub-wa-name-' + blockId);
    var phoneEl = document.getElementById('hub-wa-phone-' + blockId);
    var msgEl   = document.getElementById('hub-wa-msg-' + blockId);
    var btnEl   = document.querySelector('[data-block-id="' + blockId + '"] .whatsapp-signup__button') ||
                  (nameEl && nameEl.closest('.whatsapp-signup-block') && nameEl.closest('.whatsapp-signup-block').querySelector('.whatsapp-signup__button'));

    if (!nameEl || !phoneEl || !msgEl) return;

    var name  = (nameEl.value || '').trim();
    var local = (phoneEl.value || '').replace(/[\s\-().]/g, '');
    var sel   = _sel[blockId] || _defaultSel();

    if (!name) {
      msgEl.style.color = '#c41e3a';
      msgEl.textContent = 'Please enter your name.';
      nameEl.focus();
      return;
    }
    if (!local) {
      msgEl.style.color = '#c41e3a';
      msgEl.textContent = 'Please enter your WhatsApp number.';
      phoneEl.focus();
      return;
    }

    var fullPhone = sel.code + local.replace(/^0+/, '');
    if (btnEl) { btnEl.disabled = true; btnEl.style.opacity = '0.7'; }
    msgEl.style.color = '';
    msgEl.textContent = 'Sending…';

    var ctrl  = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, 15000);

    fetch('https://hub.littlegiants.pk/api/public/subscribe-whatsapp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: fullPhone, name: name }),
      signal: ctrl.signal
    })
      .then(function (r) { clearTimeout(timer); return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (res.ok) {
          msgEl.style.color = '#25D366';
          msgEl.textContent = '✓ Check your WhatsApp — Discount on its way!';
          nameEl.value = '';
          phoneEl.value = '';
          if (btnEl) { btnEl.disabled = true; btnEl.style.opacity = '0.5'; }
        } else {
          msgEl.style.color = '#c41e3a';
          msgEl.textContent = res.data.error || 'Something went wrong. Try again.';
          if (btnEl) { btnEl.disabled = false; btnEl.style.opacity = '1'; }
        }
      })
      .catch(function (err) {
        clearTimeout(timer);
        msgEl.style.color = '#c41e3a';
        msgEl.textContent = err.name === 'AbortError' ? 'Request timed out. Try again.' : 'Could not connect. Try again.';
        if (btnEl) { btnEl.disabled = false; btnEl.style.opacity = '1'; }
      });
  };
})();
